import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-location-exceptions',
    templateUrl: './location-exceptions.component.html',
    styleUrls: ['./location-exceptions.component.css'],
    standalone: false
})
export class LocationExceptionsComponent implements OnInit {
  @Input() locationId!: string;

  constructor() { }

  ngOnInit(): void {
  }
}
